import {CreateAdminComponent} from "./create-admin.component";

export default CreateAdminComponent;
